import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import campaignPageQuery from './query.graphql';

const CampaignContent = loadable(() =>
  import(/* webpackChunkName: "campaigns" */ './campaign')
);

const Campaign = props => <CampaignContent {...props} />;

Campaign.graphQL = campaignPageQuery;

Campaign.loadOrder = [{}];

// eslint-disable-next-line camelcase
Campaign.variables = ({ name, list, min_price, max_price }) => ({
  id: /^\d+$/.test(name) ? parseInt(name, 10) : undefined,
  campaignSlug: name,
  listSlug: list,
  limit: 20,
  minPrice: min_price,
  maxPrice: max_price,
});

Campaign.propTypes = {
  fetchMoreData: PropTypes.func,
};

Campaign.defaultProps = {
  fetchMoreData: () => {},
};

Campaign.isGiftGuide = campaign => campaign && campaign.type === 'GIFTGUIDE';

Campaign.isActive = campaign => campaign && campaign.state === 'ACTIVE';

export default Campaign;
